import React from 'react';
import { BellRing, ScanLine, Sticker } from 'lucide-react';

const STEP_ICONS = [Sticker, ScanLine, BellRing];
const STEP_COLORS = ['#FFB020', '#F59300', '#34C3A0'];

// index.tsx'ten ayrıştırıldı — landing "HowItWorks" bölümü
export default function HowItWorks({ L }: any) {
  const STEPS = L.howItWorks.steps.map((s: any, i: number) => ({ ...s, icon: STEP_ICONS[i], color: STEP_COLORS[i] }));
  return (
    <>
        <section id="how-it-works" className="py-16 md:py-24 relative">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-20">
              <div className="reveal inline-block glass-panel px-4 py-2 rounded-full text-xs text-[#FFB020] uppercase tracking-widest font-semibold mb-4">
                {L.howItWorks.badge}
              </div>
              <h2
                className="reveal reveal-delay-1 text-4xl md:text-5xl font-black text-white mb-4"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                {L.howItWorks.title}
              </h2>
              <p className="reveal reveal-delay-2 text-gray-400 text-lg max-w-xl mx-auto">
                {L.howItWorks.subtitle}
              </p>
            </div>

            <div className="relative flex flex-col md:flex-row gap-0 md:gap-0 items-stretch">
              {/* Connector line (desktop) */}
              <div className="hidden md:block absolute top-14 left-1/6 right-1/6 h-0.5 bg-gradient-to-r from-[#FFB020] via-[#F59300] to-[#34C3A0] z-0 opacity-40" style={{ left: '16.5%', right: '16.5%' }} />

              {STEPS.map((step, i) => {
                const StepIcon = step.icon;
                return (
                <div
                  key={i}
                  className={`reveal reveal-delay-${i + 1} flex-1 flex flex-col items-center text-center px-6 relative z-10`}
                >
                  {/* Step number bubble */}
                  <div
                    className="w-28 h-28 rounded-3xl glass-panel flex flex-col items-center justify-center mb-6 shadow-2xl transition-transform duration-300 hover:scale-105 gap-1.5"
                    style={{
                      border: `2px solid ${step.color}33`,
                      boxShadow: `0 0 30px ${step.color}22`,
                    }}
                  >
                    <StepIcon size={34} style={{ color: step.color }} />
                    <span
                      className="text-xs font-black tracking-widest"
                      style={{ color: step.color, fontFamily: 'var(--font-heading)' }}
                    >
                      {step.num}
                    </span>
                  </div>

                  <h3
                    className="text-xl font-bold text-white mb-3"
                    style={{ fontFamily: 'var(--font-heading)' }}
                  >
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed max-w-xs">{step.desc}</p>
                </div>
                );
              })}
            </div>
          </div>
        </section>

    </>
  );
}
